import React from 'react';
import { useQuery } from '@tanstack/react-query';
import type { ID } from '@hrms/shared';
import { api } from '../../../lib/api';
import { ApprovalTimeline, EmptyState, Loading, Modal } from '../../../ui';

/** Modal showing the approval timeline of a workflow instance. */
export function WorkflowSheet({ instanceId, onClose, title = 'Approval timeline', children }: { instanceId: ID | null; onClose: () => void; title?: string; children?: React.ReactNode }) {
  const q = useQuery({ queryKey: ['workflow-instance', instanceId], queryFn: () => api.workflow.instance(instanceId!), enabled: !!instanceId });
  return (
    <Modal open={!!instanceId} onClose={onClose} title={title} width={460}>
      {children}
      {q.isLoading ? <Loading /> : q.data ? <ApprovalTimeline instance={q.data} /> : <EmptyState title="No workflow found" />}
    </Modal>
  );
}
